module.exports = __webpack_public_path__ + "img/audi.9e8b7d2a.svg";